<template>
  <div class="renderPage fam-container" :class="{ 'theme--dark': $vuetify.theme.dark }">

    <!-- TOOLBAR CABECERA -->
    <v-toolbar flat height="56" :color="$vuetify.theme.dark ? '#1e293b' : '#f1f5f9'" class="fam-toolbar px-2">
      <v-icon class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-tag-multiple-outline</v-icon>
      <v-toolbar-title class="font-weight-black text-uppercase fam-toolbar-title" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-4'">
        Familias de Artículos
      </v-toolbar-title>
      <v-spacer />
      <v-btn depressed color="primary" class="fam-btn font-weight-bold" @click="incluir()">
        <v-icon left small>mdi-plus</v-icon> Nueva Familia
      </v-btn>
    </v-toolbar>

    <!-- TABLA -->
    <v-card flat class="fam-table-card mx-0" :color="$vuetify.theme.dark ? '#0f172a' : 'white'">
      <v-toolbar flat height="52" :color="$vuetify.theme.dark ? '#0f172a' : 'white'" class="px-3">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar familia..."
          single-line hide-details outlined dense
          class="fam-search"
          style="max-width:400px"
        ></v-text-field>
        <v-spacer />
        <v-btn icon :color="$vuetify.theme.dark ? 'blue-grey lighten-2' : 'grey darken-1'" @click="getData()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="fam-table"
        :items-per-page="25"
        :footer-props="{ 'items-per-page-options': [25, 50, -1] }"
        @click:row="editItem"
        style="cursor:pointer"
      >
        <template v-slot:[`item.codigo`]="{ item }">
          <span class="fam-code-badge">{{ item.codigo }}</span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn color="blue-grey darken-2" depressed dark class="mx-1" style="min-width:36px;height:36px;padding:0;border-radius:4px" @click.stop="editItem(item)">
            <v-icon size="18">mdi-pencil-outline</v-icon>
          </v-btn>
          <v-btn color="error" depressed dark class="mx-1" style="min-width:36px;height:36px;padding:0;border-radius:4px" @click.stop="deleteItem(item)">
            <v-icon size="18">mdi-trash-can-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:no-data>
          <div class="pa-8 text-center">
            <v-icon size="48" :color="$vuetify.theme.dark ? 'blue-grey darken-1' : 'grey lighten-1'" class="mb-3">mdi-tag-off-outline</v-icon>
            <p :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">No hay familias registradas.</p>
            <v-btn color="primary" depressed small @click="getData()">Actualizar</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- DRAWER FORMULARIO -->
    <v-navigation-drawer v-model="drawer" fixed right temporary width="420" class="fam-drawer">
      <div class="d-flex flex-column fill-height">

        <!-- HEADER DRAWER -->
        <div class="fam-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'fam-drawer-header--dark' : ''">
          <v-icon color="white" class="mr-3">{{ editedIndex > -1 ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          <div>
            <div class="white--text font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.95rem;">
              {{ editedIndex > -1 ? 'Editar Familia' : 'Nueva Familia' }}
            </div>
            <div class="caption white--text" style="opacity:0.7">{{ editedItem.codigo || 'SIN CÓDIGO' }} · Catálogo</div>
          </div>
          <v-spacer />
          <v-btn icon dark small @click="cerrar()"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <!-- FORMULARIO -->
        <div class="flex-grow-1 pa-6">
          <v-form ref="form" v-model="valid">
            <div class="fam-section-label mb-3">
              <v-icon small class="mr-1" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-information-outline</v-icon>
              <span class="font-weight-black text-caption text-uppercase" style="letter-spacing:1px" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Datos de la Familia</span>
            </div>
            <v-card flat class="fam-section-card pa-4">
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.codigo"
                    label="Código"
                    outlined dense readonly
                    prepend-inner-icon="mdi-identifier"
                    :rules="[v => !!v || 'Requerido']"
                    class="fam-readonly-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.nombre"
                    label="Nombre de la Familia"
                    outlined dense autofocus
                    prepend-inner-icon="mdi-format-text"
                    :rules="[v => !!v || 'Requerido']"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card>
          </v-form>
        </div>

        <!-- FOOTER ACCIONES -->
        <div class="fam-drawer-footer d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'fam-drawer-footer--dark' : ''">
          <v-spacer />
          <v-btn text class="mr-3 font-weight-bold fam-btn" @click="cerrar()">Cancelar</v-btn>
          <v-btn color="primary" depressed class="px-8 font-weight-bold fam-btn" :loading="loading" @click="save()">
            {{ editedIndex > -1 ? 'GUARDAR' : 'CREAR FAMILIA' }}
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";

export default {
  components: { Snackbar },
  data: () => ({
    drawer: false,
    loading: false,
    valid: false,
    search: "",
    snackText: "",
    snackValue: false,
    headers: [
      { text: "Código", value: "codigo", width: "150" },
      { text: "Nombre Familia", value: "nombre" },
      { text: "Acciones", value: "actions", align: "right", sortable: false },
    ],
    items: [],
    editedIndex: -1,
    editedItem: {
      cia: "",
      codigo: "",
      nombre: "",
    },
    defaultItem: {
      cia: "",
      codigo: "",
      nombre: "",
    },
  }),

  computed: {
    ...mapGetters(["strCia"]),
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      axios.get("api/Articulos/getFamilias?cia=" + this.strCia)
        .then(res => { this.items = res.data; })
        .catch(err => console.error(err));
    },

    generateNextCode() {
       if (this.items.length === 0) return "F-001";
       const codes = this.items.map(i => {
          const num = parseInt(i.codigo.replace(/\D/g, ''));
          return isNaN(num) ? 0 : num;
       });
       const max = Math.max(...codes);
       return "F-" + (max + 1).toString().padStart(3, '0');
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.drawer = true;
    },

    incluir() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.codigo = this.generateNextCode();
      this.drawer = true;
    },

    cerrar() {
      this.drawer = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.editedItem.cia = this.strCia;

      axios.post("api/Articulos/insertFamilia", this.editedItem)
        .then(() => {
          this.snackText = this.editedIndex > -1 ? "Familia actualizada" : "Familia creada";
          this.snackValue = true;
          this.getData();
          this.cerrar();
        })
        .catch(err => {
          console.error(err);
          this.snackText = "Error al guardar";
          this.snackValue = true;
        })
        .finally(() => { this.loading = false; });
    },

    deleteItem(item) {
      if (!confirm("¿Seguro que desea eliminar esta familia?")) return;
      axios.get(`api/Articulos/deleteFamilia?cia=${this.strCia}&codigo=${item.codigo}`)
        .then(() => {
          this.snackText = "Familia eliminada";
          this.snackValue = true;
          this.getData();
        })
        .catch(err => console.error(err));
    },
  },
};
</script>

<style scoped>
/* ===== CONTAINER ===== */
.fam-container {
  background-color: #f1f5f9;
  min-height: 100vh;
}
.theme--dark.fam-container {
  background-color: #0f172a;
}

/* ===== TOOLBAR ===== */
.fam-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.theme--dark .fam-toolbar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.07) !important;
}
.fam-toolbar-title {
  font-size: 0.95rem !important;
  letter-spacing: 1.5px;
}

/* ===== BUTTONS ===== */
.fam-btn {
  border-radius: 4px !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-size: 0.75rem !important;
}

/* ===== TABLE ===== */
.fam-table-card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}
.fam-table { background: transparent !important; }
.fam-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.07em;
  border-bottom: none !important;
}
.fam-table >>> tbody tr { cursor: pointer; }
.fam-table >>> tbody tr:hover {
  background-color: rgba(55, 71, 79, 0.05) !important;
}
.theme--dark .fam-table >>> tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* ===== CODE BADGE ===== */
.fam-code-badge {
  font-family: monospace;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 2px 6px;
  background: rgba(55, 71, 79, 0.08);
  border-radius: 3px;
  color: #37474f;
}
.theme--dark .fam-code-badge {
  background: rgba(255, 255, 255, 0.1);
  color: #b0bec5;
}

/* ===== SEARCH ===== */
.fam-search >>> .v-input__slot {
  border-radius: 4px !important;
}

/* ===== DRAWER ===== */
.fam-drawer >>> .v-navigation-drawer__content {
  background-color: #ffffff !important;
}
.theme--dark .fam-drawer >>> .v-navigation-drawer__content {
  background-color: #0f172a !important;
}

/* ===== DRAWER HEADER ===== */
.fam-drawer-header {
  background-color: #37474f;
  flex-shrink: 0;
}
.fam-drawer-header--dark {
  background-color: #263238 !important;
}

/* ===== DRAWER FOOTER ===== */
.fam-drawer-footer {
  background-color: #f8fafc;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}
.fam-drawer-footer--dark {
  background-color: #1e293b !important;
  border-top: 1px solid rgba(255, 255, 255, 0.07) !important;
}

/* ===== SECTION CARD ===== */
.fam-section-card {
  border: 1px solid rgba(0, 0, 0, 0.07) !important;
  border-radius: 4px !important;
  background-color: #ffffff !important;
}
.theme--dark .fam-section-card {
  border-color: rgba(255, 255, 255, 0.07) !important;
  background-color: #1e293b !important;
}

/* ===== SECTION LABEL ===== */
.fam-section-label {
  display: flex;
  align-items: center;
}

/* ===== READONLY INPUT ===== */
.fam-readonly-input >>> .v-input__slot {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.theme--dark .fam-readonly-input >>> .v-input__slot {
  background-color: rgba(255, 255, 255, 0.05) !important;
}
</style>
